import {
  CREATE_USER_STARTED,
  CREATE_USER_COMPLETED,
  CREATE_USER_FAILED,
  CLEAR_STATES
} from '@/store/types'

function getDefaultState () {
  return {
    loading: false,
    error: undefined,
    usernameError: undefined,
    contactError: undefined
  }
}

export default {
  namespaced: true,
  modules: {},

  state: getDefaultState(),
  getters: {},

  mutations: {
    [CREATE_USER_STARTED] (state) {
      state.loading = true
    },
    [CREATE_USER_COMPLETED] (state) {
      state.loading = false
      state.error = undefined
    },
    [CREATE_USER_FAILED] (state, err) {
      console.error(err)
      state.loading = false
      if (err.response !== undefined) {
        switch (err.response.status) {
          case 400:
          case 409: {
            const errorFields = err.response.body.details[0].field_violations.map(field => field.field)
            const errorEmail = errorFields.includes('email')
            const errorPhone = errorFields.includes('phone')
            state.contactError = errorEmail ? 'user_create.input.error.invalid_email' : undefined
            if (state.contactError === undefined) {
              state.contactError = errorPhone ? 'user_create.input.error.invalid_phone' : undefined
            }
            if (errorEmail && errorPhone) {
              if (err.response.status === 400) {
                state.contactError = 'user_create.input.error.invalid_contact'
              } else if (err.response.status === 409) {
                state.contactError = 'user_create.input.error.duplicate_contact'
              }
            }

            state.usernameError = undefined
            const errorUsername = err.response.body.details[0].field_violations.find(field => field.field === 'username')
            if (errorUsername !== undefined) {
              state.usernameError = errorUsername.description === 'duplicated' ? 'user_create.input.error.duplicate_username' : 'user_create.input.error.invalid_username'
            }
            break
          }
          case 500:
            state.error = err
            break
          default:
            state.error = err
            break
        }
      } else {
        state.error = err
      }
    },

    // Clear states
    [CLEAR_STATES] (state) {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    async create ({ commit, rootState: { client = undefined } }, data) {
      try {
        commit(CREATE_USER_STARTED)
        await client.managementClient.createUser(data)
        commit(CREATE_USER_COMPLETED)
      } catch (err) {
        commit(CREATE_USER_FAILED, err)
      }
    }
  }
}
